module.exports = __webpack_public_path__ + "static/media/img185.2dccb623.jpg";